var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tippy",rawName:"v-tippy",value:({
    theme: 'light',
    arrow: true,
    interactive: true,
    duration: [250, 250],
  }),expression:"{\n    theme: 'light',\n    arrow: true,\n    interactive: true,\n    duration: [250, 250],\n  }"}],staticClass:"app-tooltip-answer",class:{ 'app-tooltip-answer--inline': _vm.isInline },attrs:{"content":_vm.tooltip,"tabindex":"-1"}},[_c('span',{staticClass:"app-tooltip-answer__icon"},[_vm._v("?")])])}
var staticRenderFns = []

export { render, staticRenderFns }